export const isActivtiyCompletedFieldConfig = {
  read_only: false,
  required: true,
  code_name_spinner_options: [
    {
      code: 'YES',
      name: 'Yes',
    },
    {
      code: 'NO',
      name: 'No',
    },
  ],
  code: 'isTheActivityCompleted',
  hint: 'Is the activity completed?',
  type: 'code_name_spinner',
};
